import { create } from "zustand";
import Cookies from "js-cookie";
import { axiosInstance } from "../lib/axios";
import { useNavigate } from "react-router-dom";
import { deleteCategory, dowloadcategory, getAllCategoryFunction, getCategoryapi, getCategoryByIdFunction, postCategory } from "../api/category";


export const useCategoryStore = create((set, get) => ({
    category: null,
    loading: false,
    paginatedCategory: null,
    selectedCategory: null,
    // setSelectedCategory: (id) => set({ selectedCategory: id }),

    getCategory: async () => {
        set({ loading: true })
        try {
            const res = await getCategoryapi()
            set({ loading: false, category: res.ref })
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    getAllCategory: async (pageNumber, pageSize, search, field) => {
        set({ loading: true })
        try {
            const res = await getAllCategoryFunction(pageNumber, pageSize, search, field)
            console.log("getAllCategory", res)
            set({ loading: false, paginatedCategory: res?.ref })
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    getCategoryById: async (id) => {
        set({ loading: true })
        try {
            const res = await getCategoryByIdFunction(id)
            set({ loading: false })
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    addCategory: async (formData, id) => {
        set({ loading: true })
        try {
            const res = await postCategory(formData, id)
            set({ loading: false })
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    deletecategory: async (id) => {
        try {
            set({ loading: true })
            const res = await deleteCategory(id)
            const currentCategory = get().paginatedCategory || [];
            const updatedCategory = currentCategory.filter((ele) => ele._id !== id);
            set({ loading: false, paginatedCategory: updatedCategory });
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
    dowloadCategory: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true })
            const res = await dowloadcategory(pageNumber, pageSize, search, field)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Internal server error:", error);
            set({ category: null });
            return false;
        }
    },
}))